<template>
  <el-table border class="prize-content-table" v-if="productList.length>0 && productionRadio === '2'"
    :data="productList" style="width: 386px" max-height="248">
    <el-table-column property="productName" label="产品名称">
    </el-table-column>
    <el-table-column fixed="right" label="操作" width="55px">
      <template slot-scope="scope">
        <el-button @click.native.prevent="deleteRow(scope.$index, productList)" type="text" size="small">
          移除
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { FIRST_PAGE, LIMIT, SUCCESS_CODE } from './constant'
import { mapMutations } from 'vuex'
export default {
  props: {
    choosedProductList: {
      type: Array,
      default () {
        return []
      }
    },
    productionRadio: {
      type: String,
      default () {
        return null
      }
    }
  },

  watch: {
    // 父级传递过来的
    choosedProductList: {
      handler (val) {
        this.productList = val
        this.$emit('handleProductList', val)
      },
      immediate: true,
      deep: true
    }
  },


  data () {
    return {
      productList: []
    }
  },

  created () {
  },

  methods: {
    ...mapMutations(['EXCHANGE_SELECTED']),
    deleteRow (index, rows) {
      rows.splice(index, 1)
      // 重新存 已经选择的选项
      this.EXCHANGE_SELECTED(rows)
    },

  }
}
</script>
<style lang="css" scoped>
</style>